module.exports = __webpack_public_path__ + "img/instagram.0a817e3e.svg";